import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'KeysPipe' })
export class KeysPipe implements PipeTransform {
  transform(value, args: string[]): any {
    const keys = [];
    for (const enumMember in value) {
      if (value.hasOwnProperty(enumMember)) {
        keys.push({ key: enumMember, value: value[enumMember].replace(/([A-Z])/g, ' $1').trim() });
      }
    }
    return keys;
  }
}

@Pipe({ name: 'JsonKeysPipe' })
export class JsonKeyPipe implements PipeTransform {
  transform(value, args: string[]): any {
    const keys = [];
    for (const key in value) {
      if (value.hasOwnProperty(key)) {
        keys.push({ key: key, value: value[key] });
      }
    }
    return keys;
  }
}

@Pipe({ name: 'RupeeCurrencyPipe' })
export class RupeeCurrencyPipe implements PipeTransform {
  transform(x, noprefix?): any {
    let result = '0';
    if (x) {
      x = x.toString();
      x = x.split(',').join('');
      if (!isNaN(x)) {
        x = Number(x);
        x = x.toFixed(2);
        const decimal = x.split('.');
        const beforeDecimal = decimal[0];
        const afterDecimal = decimal[1];
        x = beforeDecimal;
        let lastThree = x.substring(x.length - 3);
        const otherNumbers = x.substring(0, x.length - 3);
        if (otherNumbers !== '') {
          lastThree = `,${lastThree}`;
        }
        result = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
        if (afterDecimal && afterDecimal !== '00') {
          result = `${result}.${afterDecimal}`;
        }
      }
    }
    if (noprefix) {
      return result;
    }
    return '₹ ' + result;
  }
}

@Pipe({ name: 'truncate' })
export class TruncatePipe implements PipeTransform {
  transform(value: string, args: string[]): string {
    const limit = args.length > 0 ? parseInt(args[0], 10) : 10;
    const trail = args.length > 1 ? args[1] : '...';
    return value.length > limit ? value.substring(0, limit) + trail : value;
  }
}

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(url): any {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@Pipe({name: 'safeHtml'})
export class SafeHtmlPipe implements PipeTransform {
    constructor(private sanitized: DomSanitizer) { }
    transform(value: string): any {
      return this.sanitized.bypassSecurityTrustHtml(value);
    }
}

@Pipe({ name: 'dateSuffix' })
export class DateSuffixPipe implements PipeTransform {

  transform(date: string): string {
    let suffix = 'th';
    let day = '' + date, monthYear = '';
    if (day.length > 2) {
      monthYear = day.substring(2);
      day = day.substring(0, 2);
    }
    if (day === '1' || day === '21' || day === '31') {
      suffix = 'st';
    } else if (day === '2' || day === '22') {
      suffix = 'nd';
    } else if (day === '3' || day === '23') {
      suffix = 'rd';
    }
    const fullDate: string = day + suffix + ' ' + monthYear;
    return fullDate;
  }
}
